import React from "react";
import classNames from "classnames";
import { FormGroup } from "components/common/Forms";
import DatePicker from "react-datepicker";

export const DateRange = ({
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  className,
  dateFormat = "DD/MM/YYYY",
  fromPlaceholderText,
  toPlaceholderText,
  t,
  ...props
}) => (
  <div className={classNames("d-flex", className)} {...props}>
    <FormGroup className="mb-0">
      <DatePicker
        className="form-control"
        selected={fromDate}
        onSelect={(v) => onFromDateChange(v)}
        dateFormat={dateFormat}
        placeholderText={fromPlaceholderText || t(`Start date`)}
      />
    </FormGroup>
    <div className="mx-2 align-self-center">-</div>
    <FormGroup className="mb-0">
      <DatePicker
        className="form-control"
        selected={toDate}
        onSelect={(v) => onToDateChange(v)}
        dateFormat={dateFormat}
        placeholderText={toPlaceholderText || t(`End date`)}
      />
    </FormGroup>
  </div>
);

export default DateRange;
